import { ReactElement, useMemo, useRef } from 'react';

import { CardDataSchema, IframeTypes } from '@cashier/cashier-model';

import { useCashierConfiguration } from '../../../../../../hooks';
import { useCashierMessages, useLeaderIframeMessages } from './hooks';

import styles from './styles.module.scss';

interface LeaderFieldProps {
  title: string;
  loading: 'lazy' | 'eager';
  schema: CardDataSchema;
}

export const LeaderField = ({
  title,
  loading,
  schema,
}: LeaderFieldProps): ReactElement => {
  const { cashierFieldUrl } = useCashierConfiguration();

  const iframeRef = useRef<HTMLIFrameElement>(null);

  const src = `${cashierFieldUrl}/${IframeTypes.Leader}`;

  const iframeOrigin = useMemo(() => new URL(src).origin, [src]);

  const iframeSrc = useMemo(() => {
    let url = src;
    const params = new URLSearchParams();
    params.set('host', globalThis.location.origin);

    const queryString = params.toString();
    if (queryString) {
      url += url.includes('?') ? `&${queryString}` : `?${queryString}`;
    }
    return url;
  }, [src]);

  useCashierMessages({
    iframeRef,
    schema,
    iframeOrigin,
  });

  useLeaderIframeMessages({
    iframeRef,
  });

  return (
    <iframe
      ref={iframeRef}
      src={iframeSrc}
      title={title}
      loading={loading}
      className={styles.leaderIframe}
    />
  );
};
